import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LivreurUberService {
  sacADosUber = Array();
  nombreProduits =0;

  allerChercherLaCommande(laCommande){
    this.sacADosUber = laCommande;
  }

  livrerLacommande(){
    return this.sacADosUber;
  }
 

  constructor() { }
}
